module.exports = __webpack_public_path__ + "static/logo-tecnico-4f1124d11ee647ece8516f1c13ce04ce.png";